import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION;

export const getIncidentReportPdfForm = createAsyncThunk(
  'stop/getIncidentReportPdfForm',

  async (params) => {
    const { cmpIncidentReportlUrl, authorization } = params;

    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION,
      },
    };

    try {
      const response = await axios.get(cmpIncidentReportlUrl, config);
      return response.data.data || null;
    } catch (error) {
      console.error('Error fetching PDF:', error);
      return null;
    }
  }
);

const incidentReportPdfSlice = createSlice({
  name: 'stop/IncidentReportPdfForm',
  initialState: null,
  reducers: {
    resetIncidentReportPdfForm: () => null,
  },
  extraReducers: {
    [getIncidentReportPdfForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetIncidentReportPdfForm } = incidentReportPdfSlice.actions;

export default incidentReportPdfSlice.reducer;
